import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteVentureAvatarsService = async (
  ventureId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/avatars/ventures/${ventureId}`);
};

export default deleteVentureAvatarsService;
